import React from "react";
import PageHero from "@/components/PageHero";
import Section from "@/components/Section";
import { BRAND } from "@/constants/brand";

export default function Terms() {
  return (
    <>
      <PageHero title="Terms &amp; Conditions" subtitle="Please read these terms carefully before using the HomeCure platform." />
      <Section>
        <div className="max-w-4xl mx-auto hc-prose">
          <p><strong>Effective Date:</strong> May 8, 2026. <strong>Governing Law:</strong> Laws of the Republic of India. <strong>Jurisdiction:</strong> Courts of West Bengal, India.</p>

          <h2>1. About HomeCure</h2>
          <p>HomeCure (“Platform”) is operated by {BRAND.parent} (LLPIN: {BRAND.llpin}), having its registered office at {BRAND.address}. HomeCure is a digital intermediary that connects patients with verified hospitals and healthcare personnel. {BRAND.parent} does not directly provide medical services.</p>

          <h2>2. Intermediary Status</h2>
          <p>{BRAND.parent} operates the Platform as an ‘intermediary’ within the meaning of Section 2(1)(w) of the Information Technology Act, 2000, and complies with the IT (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021. We are not a clinical establishment under the Clinical Establishments Act, 2010.</p>

          <h2>3. Three-Tier Users</h2>
          <ul>
            <li><strong>Patients / Users</strong> — individuals using the Platform to book home healthcare, hospital beds or consultations.</li>
            <li><strong>Hospitals</strong> — verified clinical establishments listing beds and personnel.</li>
            <li><strong>Healthcare Personnel</strong> — verified doctors, nurses, physiotherapists, dieticians, medical technologists and ayahs.</li>
          </ul>

          <h2>4. Commissions &amp; Payments</h2>
          <ul>
            <li>{BRAND.parent} charges a commission from <strong>patients</strong> for bookings facilitated through the Platform.</li>
            <li>Full payment for home healthcare and hospital doctor/physio/dietician consultations (in-person and video) is made online via the Platform.</li>
            <li>For hospital bed bookings, only a commission charge (based on bed type) is paid through the Platform; this is refunded if the patient does not get admitted.</li>
            <li>Final hospital bills are paid directly to the hospital. {BRAND.parent} has no role, control or liability in respect of the hospital’s final billing.</li>
          </ul>

          <h2>5. Refunds for Rejected Bookings</h2>
          <p>If a hospital or healthcare personnel rejects a booking, the full amount paid by the patient is refunded within seven (7) working days through the original payment instrument.</p>

          <h2>6. Verification</h2>
          <p>Hospitals must submit valid registration documents under the Clinical Establishments Act, 2010, and healthcare personnel must submit valid council/medical registration documents. {BRAND.parent} verifies these documents before activating accounts and reserves the right to suspend or remove accounts on detection of inaccurate or fraudulent details.</p>

          <h2>7. Acceptable Use</h2>
          <ul>
            <li>Do not impersonate any person or provide false information during registration or booking.</li>
            <li>Do not record any video consultation without the prior written consent of the consulting personnel.</li>
            <li>Do not misuse masked-audio or messaging features for spam, fraud or harassment.</li>
          </ul>

          <h2>8. Health Records</h2>
          <p>The Platform provides a secure vault for prescriptions, reports and scans. Documents are encrypted at rest. {BRAND.parent} does not provide medical advice based on stored documents; the vault is for user reference only.</p>

          <h2>9. Hospital Billing Disclaimer</h2>
          <p>{BRAND.parent}, through HomeCure, does <strong>not</strong> at any point state, estimate, indicate or guarantee the total cost of treatment, hospitalisation, procedures, medicines or any other component of a hospital’s bill. The final hospital bill is entirely determined by and payable to the hospital directly.</p>

          <h2>10. Reviews &amp; Ratings</h2>
          <p>Reviews are submitted under the user’s registered name and are moderated for compliance with applicable law and Platform policies. Defamatory, false or abusive content will be removed.</p>

          <h2>11. Limitation of Liability</h2>
          <p>{BRAND.parent}’s maximum aggregate liability for any claim arising under these Terms shall not exceed the commission amount charged from the user for the specific booking that gave rise to the claim. We are not liable for the medical advice or clinical decisions of hospitals or healthcare personnel.</p>

          <h2>12. Grievance Officer</h2>
          <p>As required under applicable law, the Grievance Officer is <strong>{BRAND.grievanceOfficer}</strong>. Contact: {BRAND.email}, {BRAND.phone}. Hours: Mon–Sat, 10:00 AM – 6:00 PM IST.</p>

          <h2>13. Changes to these Terms</h2>
          <p>We may amend these Terms from time to time. Material changes will be notified in-app or by email at least 30 days in advance.</p>

          <h2>14. Contact</h2>
          <p>For any questions about these Terms, write to {BRAND.email} or call {BRAND.phone}.</p>
        </div>
      </Section>
    </>
  );
}
